import axios from 'axios';
import qs from "qs";

let token = '';
axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
//添加请求拦截器
axios.interceptors.request.use(
  config => {
    if (sessionStorage.getItem('api_token')) {
      token = sessionStorage.getItem('api_token')
    }
    config.headers.common['Authorization'] = 'Bearer ' + token;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//添加响应拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.resolve(error.response);
  }
);
axios.defaults.baseURL = process.env.VUE_APP_BASEURL;

axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.timeout = 10000;

function checkStatus(response) {
  return new Promise((resolve, reject) => {
    if (
      response &&
      (response.status === 200 ||
        response.status === 304 ||
        response.status === 400)
    ) {
      resolve(response.data);
    } else {
      reject({
        state: "0",
        message: "网络异常"
      });
    }
  });
}
export default {
  post(url, params) {
    return axios({
      method: "post",
      url,
      data: params
    }).then(response => {
      return checkStatus(response);
    });
  },
  put(url, params) {
    return axios({
      method: "put",
      url,
      data: params
    }).then(response => {
      return checkStatus(response);
    });
  },
  delete(url, params) {
    return axios({
      method: "delete",
      url,
      data: params
    }).then(response => {
      return checkStatus(response);
    });
  },
  get(url, params) {
    // params = qs.stringify(params);
    return axios({
      method: "get",
      url,
      params
    }).then(response => {
      return checkStatus(response);
    });
  }
};